import { Button, DropdownMenu } from '@octopus-do/octopus-storybook'
import { Burger } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

export const SettingsMenuButton = React.forwardRef<HTMLButtonElement>(
  (_, ref) => {
    const { active, toggle } = DropdownMenu.useTrigger()

    return (
      <Button
        ref={ref}
        priority="secondary"
        size="medium"
        left={Burger}
        aria-label="Settings"
        active={active}
        onPointerDown={toggle}
      />
    )
  }
)
